<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Leaderboard Library</h2>
			<v-btn color="primary" @click="showAdd()">Add Leaderboard</v-btn>
		</div>

		<v-row>
			<v-col cols="3">
				<v-autocomplete
					v-model="planFilter"
					chips
					small-chips
					deletable-chips
					label="Filter by plans"
					multiple
					:items="tenantPlanList"
					item-value="id"
					:item-text="(item) => item.name + ' - ' + item.type"
					solo
					dense
				></v-autocomplete>
			</v-col>
			<v-col cols="3">
				<v-autocomplete
					v-model="tagFilter"
					:items="tagList"
					chips
					small-chips
					deletable-chips
					label="Filter by tags"
					multiple
					solo
					dense
				></v-autocomplete>
			</v-col>
			<div style="display:flex;flex-direction:row;margin-top:13px;">
				<v-btn color="primary" style="margin-right:10px;" @click="listLeaderboardLibrary">filter</v-btn>
				<v-btn color="primary" @click="resetFilter">Reset</v-btn>
			</div>
		</v-row>

		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover v-for="(entity, index) in leaderboardLibraryList.data" :key="index" v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<v-card-title>
						<span>{{ entity.name }}</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<div id="structure-view" style="display: block">
						<div class="entry-view">
							<v-img
								v-if="$root.isImage(entity.background)"
								:src="$root.asset(entity.background)"
								max-height="200"
								min-height="200"
							></v-img>
							<video
								v-else-if="$root.isVideo(entity.background)"
								width="100%"
								style="max-height: 200px; min-height: 200px"
								preload="auto"
								autoplay="autoplay"
								muted
								playsinline
								disablepictureinpicture
								loop="loop"
							>
								<source :src="$root.asset(entity.background)" type="video/mp4" />
							</video>
						</div>
					</div>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Leaderboard</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="deleteLeaderboardLibrary(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Leaderboard</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>

		<div class="d-flex flex-wrap justify-space-between" style="margin: 0px 20px 0px 30px">
			<div class="d-inline-flex">
				<span style="margin-top: 10px"> Rows per page : </span>
				<v-select
					v-model="leaderboardLibraryList.size"
					:items="rowsPerPage"
					style="margin-left: 10px; width: 80px"
					@change="listLeaderboardLibrary()"
					hide-details=""
					solo
				></v-select>
			</div>

			<v-pagination
				v-model="leaderboardLibraryList.page"
				:length="leaderboardLibraryList.length"
				:total-visible="7"
				@input="listLeaderboardLibrary()"
			></v-pagination>
		</div>

		<v-dialog v-model="dialogAdd" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Leaderboard Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formAdd" v-model="valid" @submit.prevent="addLeaderboardLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col ref="box" id="box">
											<img
												v-if="
													backgroundTemp &&
													backgroundTemp.startsWith('data') &&
													backgroundType == 'Upload' &&
													(backgroundImageName.toLowerCase().endsWith('.jpg') ||
														backgroundImageName.toLowerCase().endsWith('.jpeg') ||
														backgroundImageName.toLowerCase().endsWith('.png'))
												"
												:src="backgroundTemp"
												width="100%"
												height="auto"
											/>
											<img
												v-else-if="entity.background && backgroundType == 'URL' && $root.isImage(entity.background)"
												:src="
													entity.background.toLowerCase().startsWith('http')
														? entity.background
														: baseLocation + '/asset/file/' + entity.background
												"
												width="100%"
												height="auto"
											/>

											<video
												v-else-if="
													backgroundTemp &&
													backgroundTemp.startsWith('data') &&
													backgroundImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="auto"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="backgroundTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="entity.background && $root.isVideo(entity.background)"
												width="100%"
												height="auto"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entity.background.toLowerCase().startsWith('http')
															? entity.background
															: baseLocation + '/asset/file/' + entity.background
													"
													type="video/mp4"
												/>
											</video>
											<div v-else style="border: 5px solid black; width: 100%; height: 400px"></div>
											<!--- INPUT BACKGROUND-->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Background Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundFileName"
														label="Background"
														hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Background"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Leaderboard image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entity.background"
														prepend-icon="mdi-image"
														label="Background"
														placeholder="Background Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Leaderboard image is required']"
													></v-text-field> </v-col
											></v-row>
											<!-- END OF INPUT BACKGROUND-->
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entity.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entity.slug = entity.name ? entity.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entity.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entity.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-model="entity.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entity.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Edit Leaderboard Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formEdit" v-model="validEdit" @submit.prevent="editLeaderboardLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col ref="box" id="box">
											<img
												v-if="
													editBackgroundTemp &&
													editBackgroundTemp.startsWith('data') &&
													(backgroundImageName.toLowerCase().endsWith('.jpg') ||
														backgroundImageName.toLowerCase().endsWith('.jpeg') ||
														backgroundImageName.toLowerCase().endsWith('.png'))
												"
												:src="editBackgroundTemp"
												width="100%"
												height="auto"
											/>
											<img
												v-else-if="entityEdit.background && $root.isImage(entityEdit.background)"
												:src="
													entityEdit.background.toLowerCase().startsWith('http')
														? entityEdit.background
														: baseLocation + '/asset/file/' + entityEdit.background
												"
												width="100%"
												height="auto"
											/>

											<video
												v-else-if="
													editBackgroundTemp &&
													editBackgroundTemp.startsWith('data') &&
													backgroundImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="auto"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="editBackgroundTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="entityEdit.background && $root.isVideo(entityEdit.background)"
												width="100%"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entityEdit.background.toLowerCase().startsWith('http')
															? entityEdit.background
															: baseLocation + '/asset/file/' + entityEdit.background
													"
													type="video/mp4"
												/>
											</video>
											<div v-else style="border: 5px solid black; width: 100%; height: 400px"></div>
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Background Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundFileName"
														label="Background"
														hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Background"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Leaderboard image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entityEdit.background"
														prepend-icon="mdi-image"
														label="Background"
														placeholder="Background Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Leaderboard image is required']"
													></v-text-field> </v-col
											></v-row>
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entityEdit.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entityEdit.slug = entityEdit.name ? entityEdit.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entityEdit.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entityEdit.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
											v-if="isTargetOne"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-model="entityEdit.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length>0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entityEdit.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!validEdit" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
#structure-view .entry-view {
	max-width: 100%;
	margin: 0 auto;
}
.entry-view {
	position: relative;
}
.structure-link {
	cursor: pointer;
	position: absolute;
}
.longtext {
	max-width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			validEdit: true,
			dialogAdd: false,
			dialogEdit: false,
			leaderboardLibraryList: { data: [], page: 1, size: 8, length: 0, total: 0 },
			entity: { dataMap: {}, linkToDataList: [], planList: [] },
			entityEdit: { planList: [] },
			backgroundType: "Upload",
			attachment1: null,
			baseLocation: axios.defaults.baseURL,
			tenantPlanList: [],
			tenantList: [],
			backgroundFileName: "",
			backgroundImageName: "",
			editBackgroundTemp: "",
			backgroundTemp: "",
			isTargetOne: false,
			tagList: [],
			tagFilter: [],
			planFilter: [],
			rowsPerPage: [8, 16, 32, 64]
		};
	},
	mounted() {
		this.listLeaderboardLibrary();
		this.listTenantPlan();
		this.listTenant();
		this.listTag();
	},
	methods: {
		listLeaderboardLibrary() {
			axios.post("/system/leaderboardlibrary/list", {
					planFilter: this.planFilter,
					tagFilter: this.tagFilter,
					tenantPlanId: null,
					page: this.leaderboardLibraryList.page,
					size: this.leaderboardLibraryList.size
				}).then((response) => {
				this.leaderboardLibraryList = response.data;
				// Check if small asset is exist and use it
				let vm = this;
				this.leaderboardLibraryList.data.map(obj => {
					vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function(status) {
						if (status) {
							obj.background = vm.$root.smallAsset(obj.background)
						}
					});
					return obj;
				});
			});
		},
		listTag() {
			axios.get("/system/leaderboardlibrary/tag/list").then(response => {
				this.tagList = response.data;
			});
		},
		resetFilter(){
			this.planFilter = [];
			this.tagFilter = [];
			this.leaderboardLibraryList.page = 1;
			this.leaderboardLibraryList.size = 8;
			this.listLeaderboardLibrary();
		},
		deleteLeaderboardLibrary(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/leaderboardlibrary/delete", { id: id }).then(() => {
					this.listLeaderboardLibrary();
				});
			}
		},
		addLeaderboardLibrary() {
			if (this.isTargetOne) {
				this.entity.planList = [];
			} else {
				this.entity.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/leaderboardlibrary/add", formData).then(() => {
				this.listLeaderboardLibrary();
				this.listTag();
				this.entity = {
					dataMap: {},
				};
				this.$refs.formAdd.reset();
				this.clearData();
				this.dialogAdd = false;
			});
		},
		editLeaderboardLibrary() {
			if (this.isTargetOne) {
				this.entityEdit.planList = [];
			} else {
				this.entityEdit.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/leaderboardlibrary/edit", formData).then(() => {
				this.listLeaderboardLibrary();
				this.listTag();
				this.entityEdit = {
					dataMap: {},
					linkToDataList: [],
				};
				this.$refs.formEdit.reset();
				this.clearData();
				this.dialogEdit = false;
			});
		},
		showAdd() {
			this.backgroundType = "Upload";
			this.entity = {
				dataMap: {},
				linkToDataList: [],
			};
			this.dialogAdd = true;
		},
		showEdit(item) {
			this.entityEdit = { ...item };
			if (this.entityEdit.background) {
				this.entityEdit.background = this.$root.reverseToOriginal(this.entityEdit.background);
			}
			this.isTargetOne = this.entityEdit.targetId ? true : false;
			if (this.entityEdit.dataMap.bannerRotatingVideo) {
				this.bannerRotatingVideoType = "URL";
			} else {
				this.bannerRotatingVideoType = "Upload";
			}
			if (this.entityEdit.background) {
				this.backgroundType = "URL";
			} else {
				this.backgroundType = "Upload";
			}
			this.dialogEdit = true;
		},
		closeAdd() {
			this.entity = {
				dataMap: {},
				linkToDataList: [],
			};
			this.dialogAdd = false;
			this.$refs.formAdd.reset();
			this.clearData();
		},
		closeEdit() {
			this.entityEdit = {
				mainStructure: false,
				dataMap: {},
				linkToDataList: [],
			};
			this.dialogEdit = false;
			this.$refs.formEdit.reset();
			this.clearData();
		},
		listTenantPlan() {
			axios.post("/system/tenantplan/list/type", { type: "Exhibition" }).then((response) => {
				this.tenantPlanList = response.data;
			});
		},
		listTenant() {
			axios.get("/system/tenant/list").then((response) => {
				this.tenantList = response.data;
			});
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundTemp = fr.result;
					} else {
						this.editBackgroundTemp = fr.result;
					}
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundImageName = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		openBackgroundDialog() {
			this.$refs.attachment1.click();
		},
		clearData() {
			this.attachment1 = null;
			this.backgroundFileName = "";
			this.backgroundImageName = "";
			this.editBackgroundTemp = "";
			this.backgroundTemp = "";
		},
	},
};
</script>
